"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TServiceIssueStatus = exports.TResolutionType = void 0;
var TResolutionType;
(function (TResolutionType) {
    TResolutionType["REPAIR"] = "REPAIR";
    TResolutionType["SWAP"] = "SWAP";
    TResolutionType["NO_ISSUE"] = "NO_ISSUE";
})(TResolutionType || (exports.TResolutionType = TResolutionType = {}));
var TServiceIssueStatus;
(function (TServiceIssueStatus) {
    TServiceIssueStatus["CREATED"] = "CREATED";
    TServiceIssueStatus["FLAGGED_FOR_SERVICE"] = "FLAGGED_FOR_SERVICE";
    TServiceIssueStatus["SERVICE_COMPLETED"] = "SERVICE_COMPLETED";
    TServiceIssueStatus["CLOSED_FIXED"] = "CLOSED_FIXED";
    TServiceIssueStatus["CLOSED_UNFIXED"] = "CLOSED_UNFIXED";
})(TServiceIssueStatus || (exports.TServiceIssueStatus = TServiceIssueStatus = {}));
//# sourceMappingURL=node-service-issues.js.map